export const basciUrl = 'https://www.tksmapi.com'